export default {
      id: "google-play-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#google-play",
      toString: function () {
        return this.url;
      }
    }